import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { observer } from 'mobx-react';
import { IAdminxStore } from '../../modules/stores';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import { useRoute } from '../../modules/hooks/tools/use-route';
import { useBidderDomainsHeaders } from '../../modules/hooks/theaders/bidder-domains.headers';
import { BidderDomainCounter, CampaignDomainTagCounters } from '../../modules/models/bidder-domains.model';
import { useList } from '../../modules/hooks/tools/use-list';
import { sortData } from '../../modules/hooks/tools/use-merge-with-performance';
import { usePageSettings } from '@monorepo/tools/src/lib/hooks/tools/use-page-settings';
import { useStateBetweenPages } from '../../modules/hooks/tools/use-state-between-pages';
import { useBidderDomainsActions } from '../../modules/hooks/actions/bidder-domains-campaign.actions';
import styles from './bidder-domains.module.scss';

export const BidderDomains = observer(() => {
	const { bidderDomainsStore } = useStores<IAdminxStore>();

	const { currentRouteWithoutSpecialChars } = useRoute();
	const sortBy = usePageSettings().tableStore?.getSortingBy();
	const stateBetweenPages = useStateBetweenPages(() => bidderDomainsStore.campaignDomainTagCounters.getList().length !== 0);

	useList<CampaignDomainTagCounters>(bidderDomainsStore.campaignDomainTagCounters, undefined, stateBetweenPages);
	useList<BidderDomainCounter>(bidderDomainsStore.pausedInCache, undefined, stateBetweenPages);
	useList<BidderDomainCounter>(bidderDomainsStore.domainsInTrash, undefined, stateBetweenPages);

	const { columns } = useBidderDomainsHeaders();
	const { FiltersActions } = useBidderDomainsActions();

	const sortedList = sortData(bidderDomainsStore.getTableData(), sortBy?.[0]);

	return (
		<Page>
			<Pagebar>
				<PagebarTitle>Domains Manager</PagebarTitle>
			</Pagebar>

			<ControlledTable
				classes={{ wrapper: styles.table }}
				currentRoute={currentRouteWithoutSpecialChars}
				columns={columns}
				data={sortedList}
				defaultSortBy={sortBy}
				isLoading={bidderDomainsStore.campaignDomainTagCounters.getIsLoading()}>
				{() => {
					return {
						FiltersActions,
					};
				}}
			</ControlledTable>
		</Page>
	);
});
